import React, { useState, useEffect } from "react";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "components/ui/dialog";

function EditCreditModal({ isOpen, onClose, onSave, creditData }) {
  const [formData, setFormData] = useState({
    clientName: "",
    phone: "",
    value: "",
    expirationDate: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Populate form when modal opens or creditData changes
  useEffect(() => {
    if (creditData && isOpen) {
      setFormData({
        clientName: creditData.clientName || "",
        phone: creditData.phone || "",
        value: creditData.value || "",
        expirationDate: creditData.expirationDate
          ? creditData.expirationDate.toISOString().split("T")[0]
          : "",
      });
    }
  }, [creditData, isOpen]);

  if (!isOpen || !creditData) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    
    try {
      // Parse values
      const updatedData = {
        clientName: formData.clientName,
        phone: formData.phone,
        value: parseFloat(formData.value) || 0,
        expirationDate: formData.expirationDate
          ? new Date(formData.expirationDate + "T12:00:00") // Add time to avoid timezone shift
          : null,
      };

      const success = await onSave(creditData.id, updatedData);
      if (success) {
        onClose();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent aria-describedby={undefined} className="w-full h-[100dvh] max-h-none sm:h-auto sm:max-h-[85vh] sm:max-w-md p-0 border-0 sm:border rounded-none sm:rounded-lg overflow-hidden flex flex-col">
        <DialogHeader className="px-6 py-4 border-b shrink-0 bg-white dark:bg-background">
          <DialogTitle>Editar Crédito</DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="flex flex-col flex-1 overflow-hidden">
          <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4 content-start">
            <div className="space-y-2">
              <Label htmlFor="clientName">Nome do Cliente</Label>
              <Input
                id="clientName"
                name="clientName"
                value={formData.clientName}
                onChange={handleChange}
                placeholder="Ex: João Silva"
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="phone">Telefone</Label>
              <Input
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Ex: 79999999999"
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="value">Valor (R$)</Label>
              <Input
                id="value"
                name="value"
                type="number"
                step="0.01"
                min="0"
                value={formData.value}
                onChange={handleChange}
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="expirationDate">Data de Validade (Opcional)</Label>
              <Input
                id="expirationDate"
                name="expirationDate"
                type="date"
                value={formData.expirationDate}
                onChange={handleChange}
                className="force-light-datepicker"
              />
            </div>
          </div>

          <DialogFooter className="px-6 py-4 border-t shrink-0 bg-gray-50 dark:bg-card mt-auto gap-2 flex-col-reverse sm:flex-row">
            <Button type="button" variant="outline" onClick={onClose} className="w-full sm:w-auto">
              Cancelar
            </Button>
            <Button type="submit" disabled={isSubmitting} className="w-full sm:w-auto">
              {isSubmitting ? "Salvando..." : "Salvar Alterações"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default EditCreditModal;
